import { render, staticRenderFns } from "./BtnInserirParecerFinanceiro.vue?vue&type=template&id=962115b8"
import script from "./BtnInserirParecerFinanceiro.vue?vue&type=script&lang=js"
export * from "./BtnInserirParecerFinanceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports